import { Column } from "primereact/column"
import { DataTable } from "primereact/datatable"
import { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"
import { queryDataQualtityMatrix } from "../../../utility/service/carbonFootprint-service"
import { checkDpSuccess } from "../../../utility/service/tool-service"
import NoInfo from "../../../components/NoInfo"

const DataQualityMatrixTable = ({rows,maxLevels=5}) => {
    const { t } = useTranslation();

    // 🔁 動態轉換資料
    const transformedData = rows.map((item) => {
        const row = { levelIndicator: item.levelIndicator };
        for (let i = 0; i < maxLevels; i++) {
        row[`levelDescription${i + 1}`] = item.levelDescription[i] || ''; // 若沒有就空字串
        }
        return row;
    });

    return (
    <>
    <DataTable value={transformedData}  emptyMessage={<NoInfo panel="table" size="md" />} >
        <Column style={{width:'180px'}} field="levelIndicator" header={t('levelIndicator')} />
        {[...Array(maxLevels)].map((_, i) => (
        <Column
            key={i}
            field={`levelDescription${i + 1}`}
            header={`${i + 1}`}
        />
        ))}
    </DataTable>

    </>
    )
}

export default DataQualityMatrixTable